import { FormProps, Input } from '@alphabait/ui/form'
import { useController } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import i18n from '../../i18n'
import { AlphaTypes } from './custom-types'
import style from './form.module.css'

export default function CustomInput({
  field,
  formProps,
}: {
  field: Input
  formProps: FormProps
}) {
  const { t } = useTranslation()

  const {
    field: { onChange, value, ref },
    fieldState: { error },
  } = useController({
    control: formProps.control,
    name: field.name,
    defaultValue: field.value,
  })

  const inputType = field.uiOptions?.inputType || 'text'

  return (
    <div>
      <input
        type={inputType}
        placeholder={field.uiOptions?.placeholder}
        className={
          // reason: a colour input paints its swatch inside the content box, so the
          // shared padding and white background of .customInput squeeze it away to
          // nothing. Same swatch reset the gift-portal theme editor uses.
          inputType === 'color' ? style.customColorInput : style.customInput
        }
        onChange={onChange}
        name={field.name}
        value={value || ''}
        ref={ref}
        data-testid={field.uiOptions?.testId}
        disabled={field.uiOptions?.disabled}
      />
      {error && (
        <span
          className={style.errorMessage}
          data-testid={`${field.name}-error`}
        >
          {t(`validation_messages.${error.message}`)}
        </span>
      )}
    </div>
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export const getCustomInputProperties = () =>
  [
    {
      name: 'uiOptions.label',
      type: 'input',
      uiOptions: {
        label: i18n.t('questionnaire_builder.question'),
        inputType: 'text',
      },
      validations: ['required'],
    },
    {
      name: 'validation.minLength',
      type: 'input',
      uiOptions: {
        label: i18n.t('questionnaire_builder.min_length'),
        inputType: 'number',
      },
    },
    {
      name: 'validation.maxLength',
      type: 'input',
      uiOptions: {
        label: i18n.t('questionnaire_builder.max_length'),
        inputType: 'number',
      },
    },
    {
      name: 'validation.required',
      customControlType: 'switch',
      type: 'custom',
      uiOptions: {
        label: i18n.t('questionnaire_builder.required'),
      },
    },
  ] as AlphaTypes[]
